<template>
  <div class="subscriptionModalFail">
    <SubscriptionModalHeader @closeModal="closeModal" />
    <div class="subscriptionModalFail__body">
      <h2 class="subscriptionModalFail__title">Something went wrong.</h2>
      <div class="subscriptionModalFail__description">
        It looks like something went wrong when trying to subscribe to Cofocus Premium. Please try again or contact us at support@cofocus.one.
      </div>
    </div>
    <ELYXButton @click="closeModal">Close</ELYXButton>
  </div>
</template>

<script>
import ELYXButton from "../../ELYXComponents/ELYXButton.vue";
import SubscriptionModalHeader from "./SubscriptionModalHeader.vue";
import { ELYXCentralStore } from "../ELYXStore";

export default {
  components: {
    ELYXButton,
    SubscriptionModalHeader,
  },
  methods: {
    closeModal: ELYXCentralStore.methods.closeModal,
  },
};
</script>

<style scoped>
.subscriptionModalFail {
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
  padding: 15px;
  width: 100%;
  max-width: 465px;
  box-sizing: border-box;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  border-radius: 14px;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
/* styles applied when viewport width is 600px or less */
@media (max-width: 500px) {
  .subscriptionModalFail {
    max-width: unset;
    width: 100vw;
    border-radius: 0px;
  }
}

/* styles applied when viewport height is 900px or less */
@media (max-height: 300px) {
  .subscriptionModalFail {
    height: 100vh;
    overflow-y: scroll;
    border-radius: 0px;
  }
}
.subscriptionModalFail__body {
  display: flex;
  flex-direction: column;
  margin: 15px auto;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  padding: 30px;
  background: #ffffffa3;
  width: 100%;
  box-sizing: border-box;
}
.subscriptionModalFail__title {
  margin-bottom: 15px;
  font-size: 20px;
  color: black;
  font-weight: 600;
  text-align: center;
}
.subscriptionModalFail__description {
  line-height: 24px;
}
</style>
